import type {
  ColumnMappingComponents,
  ColumnMappingReferences,
} from '@ardoq/api-types/integrations';

type ComponentsColumnType = ColumnMappingComponents['columnType'];
type ReferencesColumnType = ColumnMappingReferences['columnType'];

export const COMPONENTS_COLUMN_TYPES: readonly ComponentsColumnType[] = [
  'custom-id',
  'component-path',
  'component',
  'ardoq-oid',
  'component-key',
  'component-type',
  'field',
  'description',
  'tags',
  'parent',
  'reference',
];

export const REFERENCES_COLUMN_TYPES: readonly ReferencesColumnType[] = [
  'root-reference',
  'target-reference',
  'custom-id',
  'ardoq-oid',
  'reference-type',
  'field',
  'description',
  'display-text',
  'tags',
];

export const COMPONENTS_SINGLE_USE_COLUMN_TYPES: readonly ComponentsColumnType[] =
  [
    'custom-id',
    'ardoq-oid',
    'component-key',
    'component-type',
    'component-path',
    'description',
    'tags',
    'parent',
  ];

export const REFERENCES_SINGLE_USE_COLUMN_TYPES: readonly ReferencesColumnType[] =
  [
    'custom-id',
    'ardoq-oid',
    'reference-type',
    'root-reference',
    'target-reference',
    'description',
    'display-text',
    'tags',
  ];

export const isOneOfColumnTypes = <ColumnType extends string>(
  columnTypes: readonly ColumnType[],
  columnType: string
): columnType is ColumnType => columnTypes.some(type => type === columnType);
